// Which failed write the toast tells. The toast shows the newest live
// failure with Retry. When that failure leaves the list (retried, or
// retired by a resend), its toast goes; when its toast closes (dismissed,
// timed out, or replaced by another message), the failure is given up, so
// its saved text returns to its box. With several, the toast says so
// ("1 of 3 failed writes"), each told in turn with its own Retry.
import type { FailedWrite } from './pending.svelte';
import type { Toast, ToastMessage } from './toast.svelte';

export class FailureToast<K extends string> {
  private told: { failure: FailedWrite<K>; message: ToastMessage; count: number } | null = null;

  constructor(private toast: Toast) {}

  /** Bring the toast in line with the live failures; call it whenever either changes. */
  sync(live: readonly FailedWrite<K>[]): void {
    const told = this.told;
    if (told && !live.includes(told.failure)) {
      if (this.toast.message === told.message) this.toast.dismiss();
      this.told = null;
    } else if (told && this.toast.message !== told.message) {
      this.told = null;
      // Giving it up changes the list, and the caller syncs again.
      told.failure.dismiss();
      return;
    }
    const top = live.at(-1);
    if (!top || (top === this.told?.failure && live.length === this.told.count)) return;
    const more = live.length > 1 ? ` (1 of ${live.length} failed writes; the others follow)` : '';
    this.toast.show({
      text: `${top.label} failed: ${top.error.text}${more}`,
      link: top.error.link,
      linkText: top.error.linkText,
      action: { label: 'Retry', run: () => void top.retry() },
    });
    this.told = { failure: top, message: this.toast.message!, count: live.length };
  }
}
